export const NotificationsFlow = {
  NATIVE: 'native',
  WEBVIEW: 'webview',
};
